import { render, staticRenderFns } from "./EcaStatusHistoryDialog.vue?vue&type=template&id=68bf7fec&scoped=true&"
import script from "./EcaStatusHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./EcaStatusHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./EcaStatusHistoryDialog.vue?vue&type=style&index=0&id=68bf7fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf7fec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VDivider,VIcon,VSimpleTable})
